import React from 'react';

import avatar from '../../images/me.jpg';
import * as Styles from './styles';

export default ({ onClick, animation = {}, imageAnimation = {} }) => (
    <Styles.Avatar onClick={ onClick } animation={ animation }>
        <Styles.Image src={ avatar } animation={ imageAnimation } />
    </Styles.Avatar>
);
